module.exports = __webpack_public_path__ + "static/media/hours_worked.3b0b53dc.svg";